export const Sectors = [
  "Familie",
  "Freund*innen / Bekannte",
  "Kolleg*innen",
  "prof. Helfer*innen",
];
export const SectorsEng = ["Family", "Friends", "Colleagues", "prof. Help"];

export const SectorDefaultRoles = [
  "Familienangehörige*r",
  "Freund*in",
  "Kolleg*in",
  "prof. Helfer*in",
];

export const SectorDefaultRolesEng = [
  "Family member",
  "Friend",
  "Colleague",
  "prof. Help",
];
